/** Stable routes exported from the backend alongside the shared brand package. */
import routes from './product-routes.generated.json';
export const PRODUCT_ROUTES = Object.freeze(routes);
